webpackJsonp([35783957827783],{

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(49);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data;
	    var posts = data.allMarkdownRemark.edges;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      posts.map(function (_ref) {
	        var post = _ref.node;
	        return _react2.default.createElement(
	          'article',
	          { className: 'card mb-4' },
	          _react2.default.createElement(
	            'header',
	            { className: 'card-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card-meta' },
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                _react2.default.createElement(
	                  'time',
	                  { className: 'timeago', dateTime: post.frontmatter.date },
	                  post.frontmatter.date
	                )
	              ),
	              ' in ',
	              _react2.default.createElement(
	                'a',
	                { href: 'page-category.html' },
	                'Journey'
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: post.fields.slug },
	              _react2.default.createElement(
	                'h4',
	                { className: 'card-title' },
	                post.frontmatter.title
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.fields.slug },
	            _react2.default.createElement('img', { className: 'card-img', src: post.frontmatter.defaultImage, alt: '' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'card-body' },
	            _react2.default.createElement(
	              'p',
	              { className: 'card-text' },
	              post.excerpt
	            )
	          )
	        );
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  })
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-95a80599d54be21b6a2c.js